import { createWorkerSearch } from "./client.ts";
import type { SearchClient } from "./types.ts";

// Ponto único de criação da busca: MiniSearch num Web Worker (client.ts + worker.ts).
export function createSearch(): SearchClient {
  return createWorkerSearch();
}
export { ENTITY_WORD, GRAMMAR_VERSION, serverQuery } from "./parser.ts";
export type { ColorFacet, ParsedQuery, SearchClient, SearchResult } from "./types.ts";
